import { useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { request_id_for } from '../rules_engine/logic';
import { keeps_request_id, payout_error } from './adapters';

/*
 * PROD-7828 W4 — a money write with a client_request_id. The id is minted once per attempt and kept while
 * the content is unchanged and no answer came back, so "Try again" after a dropped request replays it
 * instead of paying twice; any real answer (or an edit) retires it.
 * send(signature, post(id)) -> Promise resolving {ok, data} or {ok:false, err} (err: payout_error's shape).
 */
const useIdempotentPost = (failed_text, new_id = uuidv4) => {
  const idem = useRef(null);
  const [busy, setBusy] = useState(false);

  const send = (signature, post) => {
    idem.current = request_id_for(idem.current, signature, new_id);
    setBusy(true);
    return post(idem.current.id).then(
      (data) => {
        idem.current = null;
        setBusy(false);
        return { ok: true, data };
      },
      (e) => {
        const err = payout_error(e, failed_text);
        if (!keeps_request_id(err)) idem.current = null;
        setBusy(false);
        return { ok: false, err, raw: e };
      }
    );
  };

  return { busy, send };
};

export default useIdempotentPost;
